import React from "react";
import { Scatter } from "react-chartjs-2";
import { ChartOptions, ChartData } from "chart.js";
import { Container } from "semantic-ui-react";
import { Dispatch } from "redux";

interface LiveGraphProps {
    chartData: any;
    maxTime: any;
    maxValue: any;
    userId?: any;
    strength?: string;
    calibrationWeight?: number; // Added calibration weight prop
}

interface LiveGraphState {
    redirect: boolean;
    chartData?: any;
}

class LiveGraph extends React.PureComponent<LiveGraphProps, LiveGraphState> {
    constructor(props: LiveGraphProps) {
        super(props);
        this.state = { 
            redirect: false
        };
    }

    render() {
        const chartData = this.generateChartData();
        const chartOptions = this.generateChartOptions();

        return (
            <Container style={{position: "fixed", left:0,top:"0%", width:"100%", height:"100%"}}>
            <Container style={{position: "absolute",height:"100%",width:"100%",margin:"0 0"}}>
                <Scatter data={chartData} options={chartOptions}/>    
            </Container>
            </Container>
        );
    }

    private processChartData(rawData: any[]): any[] {
        if (!rawData || rawData.length === 0) return [];
        
        // Data is already processed in Exercise component, just ensure no negative values
        return rawData.map(dataPoint => {
            if (!dataPoint || typeof dataPoint.y !== 'number') return dataPoint;
            return {
                ...dataPoint,
                y: Math.max(0, dataPoint.y) // Ensure no negative values
            };
        });
    }

    private generateChartData(): ChartData<'scatter'> {
        const processedData = this.processChartData(this.props.chartData || []);
        
        return {
            labels: ["Scatter"],
            datasets: [{
                label: "Effort",
                fill: false,
                showLine: true,
                backgroundColor: "rgba(192,89,54,1)",
                pointBorderColor: "rgba(192,89,54,1)",
                pointBackgroundColor: "#fff",
                pointBorderWidth: 0,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "rgba(192,89,54,1)",
                pointHoverBorderColor: "rgba(220,220,220,1)",
                pointHoverBorderWidth: 0,
                pointRadius: 0,
                pointHitRadius: 9,
                borderColor: "rgba(192,89,54,1)",
                data: processedData,
                tension: 0.4,
                spanGaps: false
            }]
        };
    }

    private generateChartOptions(): ChartOptions<'scatter'> {
        return {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                    labels: {
                        color: "rgba(255, 255, 255,0.2)"
                    }
                },
                tooltip: {
                    callbacks: {
// tslint:disable-next-line: typedef
                        label: function(context: any) {
                            return Number(context.parsed.y) + " kg";
                        }
                    },
                    backgroundColor: "#fff",
                    titleColor: "#0066ff",
                    titleFont: {
                        size: 16,
                    },
                    bodyColor: "#000",
                    bodyFont: {
                        size: 14,
                    },
                    displayColors: false
                }
            },
            elements: {
                line: {
                    tension: 0.4 // increased from 0 for better smoothing
                }
            },
            scales: {
                y: {
                    min: 0, // Always start Y-axis at 0
                    title: {
                        display: false,
                        text: "Force",
                        color: "rgba(255, 255, 255,0.95)"
                    },
                    grid: {
                        display: false,
                        color: "rgba(255, 255, 255,0.1)"
                    },
                    ticks: {
                        display: true,
                        autoSkip: true,
                        color: "rgba(255, 255, 255,0.6)"
                    }
                },
                x: { 
                    position: "bottom",
                    title: {
                        display: false,
                        text: "seconds",
                        color: "rgba(255, 255, 255,0.95)",
                    },
                    grid: {
                        display: false,
                        color: "rgba(255, 255, 255,0.1)"
                    },
                    ticks: {
                        autoSkip: true,
                        maxRotation: 0,
                        display: true,
                        color: "rgba(255, 255, 255,0.6)"
                    }
                },
            },
            animation: {
                duration: 0
            },
            hover: {
                mode: 'nearest',
                intersect: false,
            },
            spanGaps: false,
        };
    }
}

export default LiveGraph;
